import { TrendingUp } from "lucide-react";
import { FALLBEISPIELE } from "../data/fallbeispiele";

// „So viel haben unsere Kunden durchgesetzt" – zeigt ausschließlich echte,
// vom Inhaber gepflegte Fallbeispiele (src/data/fallbeispiele.js).
// Solange keine echten Fälle vorliegen, bleibt der Bereich ausgeblendet.
export const FallbeispieleBlock = () => {
  if (!FALLBEISPIELE.length) return null;
  return (
    <section className="py-16 bg-slate-50" data-testid="fallbeispiele-block">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-navy">So viel haben unsere Kunden durchgesetzt</h2>
        <p className="mt-3 text-slate-600 max-w-2xl">Echte Fälle aus Köln und NRW – mit dem Unterschied, den ein unabhängiges Gutachten macht.</p>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {FALLBEISPIELE.map((f, i) => (
            <article key={i} className="bg-white border border-slate-200 rounded-xl p-5" data-testid={`fallbeispiel-${i}`}>
              <p className="text-xs font-bold uppercase tracking-wider text-slate-400">{f.schaden} · {f.ort}</p>
              <p className="mt-2 flex items-center gap-2 font-display text-2xl font-bold text-emerald-600"><TrendingUp size={20} /> {f.durchgesetzt}</p>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{f.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
